import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=01e5db58&scoped=true"
import script from "./Header3.vue?vue&type=script&lang=js"
export * from "./Header3.vue?vue&type=script&lang=js"
import style0 from "./Header3.vue?vue&type=style&index=0&id=01e5db58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e5db58",
  null
  
)

export default component.exports